import { IProductSlotBooking } from "@/types/db/product-slot-booking";

import { IAccountingEntry } from "@/types/db/accounting-entry";
import { Currencies } from "@/constants/currency";

export enum AccountingState {
  Pending = 1,
  Started,
  Authorized,
  Tokenized,
  Completed,
  Failed,
  Cancelled,
}

export enum PaymentMethods {
  METHOD_POS_UNKNOWN = "UNKNOWN",
  METHOD_POS_CASH = "CASH",
  METHOD_POS_ADYEN = "POS_ADYEN",
  METHODS_DISCOUNT = "DISCOUNT",
  METHODS_POS_DISCOUNT = "POS_DISCOUNT",
  METHODS_POS_CARD = "POS_CARD",
  METHODS_POS_BANK_TRANSFER = "BANK_TRANSFER",
  METHODS_POS_INVOICE = "INVOICE",
  METHODS_POS_TO_BE_INVOICED = "TO_BE_INVOICED",
  METHODS_POS_FREE = "FREE",
  METHODS_TICKET_POS = "TICKET_POS",
  METHODS_POS_CHEQUE = "CHEQUE",
  METHODS_POS_CHEQUE_VACANCES = "CHEQUE_VACANCES",
  METHODS_POS_CHEQUE_CULTURE = "CHEQUE_CULTURE",
  METHODS_POS_PASS_CULTURE = "PASS_CULTURE",
  METHODS_POS_CHORUS = "CHORUS",
  METHODS_POS_CE = "CE",
  METHODS_POS_OCCYG = "OCCYG",
  METHODS_POS_COUPON_SPORT = "COUPON_SPORT",
  METHODS_TAX_POS = "TAX_POS",
  POS_PROMO_CODE = "POS_PROMO_CODE",
  POS_VOUCHER = "POS_VOUCHER",
  POS_GIFT_CARD = "POS_GIFT_CARD",
  POS_MEMBERSHIP = "POS_MEMBERSHIP",

  METHOD_UNKNOWN = "UNKNOWN",
  METHOD_PROMO_CODE = "PROMO_CODE",
  METHOD_VOUCHER = "VOUCHER",
  METHOD_GIFT_CARD = "GIFT_CARD",
  METHOD_MEMBERSHIP = "MEMBERSHIP",
  METHOD_DISCOUNT = "DISCOUNT",
  METHOD_QOQA_VOUCHER = "QOQA_VOUCHER",
  METHOD_MEMBERSHIP_DISCOUNT = "MEMBERSHIP_DISCOUNT",
  METHOD_EXPERIENCEBANK = "EXPERIENCEBANK",
  METHOD_INVITATION = "invitation",
  METHOD_REFUNDED_VOUCHER = "REFUNDED_VOUCHER",
  METHOD_VISA = "VISA",
  METHOD_MASTERCARD = "MASTERCARD",
  METHOD_AMEX = "AMEX",
  METHOD_TWINT = "TWINT",
  METHOD_POST_CARD = "POSTCARD",
  METHOD_PAYPAL = "PAYPAL",
  METHOD_POSTFINANCE_EFINANCE = "POSTEFINANCE",
  METHOD_INVOICE = "INVOICE",
  METHOD_BANK_TRANSFER = "BANK_TRANSFER",
  METHOD_FREE = "FREE",
  METHOD_EXTERNAL_VOUCHER = "EXTERNAL_VOUCHER",
  METHOD_CASH = "CASH",
  METHOD_CHEQUE = "CHEQUE",
  METHOD_CHEQUE_CULTURE = "CHEQUE_CULTURE",
  METHOD_CHEQUE_VACANCES = "CHEQUE_VACANCES",
  METHOD_PASS_CULTURE = "PASS_CULTURE",
  METHOD_POS_CHORUS = "CHORUS",
  METHOD_STAND_ALONE_ADYEN = "STAND_ALONE_ADYEN",
  METHOD_POS_ADYEN_CREATE_ORDER = "POS_ADYEN_CREATE_ORDER",
  METHOD_KIOSK_ADYEN = "KIOSK_ADYEN",
  METHOD_POS_CARD = "POS_CARD",
  METHOD_B2B_POS_CASH = "POS_CASH",
  METHOD_POS_TWINT = "POS_TWINT",
  METHOD_POS_INVOICE = "POS_INVOICE",
  METHOD_POS_BANK_TRANSFER = "POS_BANK_TRANSFER",
  METHOD_POS_INVITATION = "POS_INVITATION",
  METHOD_POS_EXTERNAL = "POS_EXTERNAL",
  METHOD_B2B_POS_PROMO_CODE = "POS_PROMO_CODE",
  METHOD_B2B_POS_VOUCHER = "POS_VOUCHER",
  METHOD_B2B_POS_GIFT_CARD = "POS_GIFT_CARD",
  METHOD_B2B_POS_MEMBERSHIP = "POS_MEMBERSHIP",
  METHOD_SPONSORED = "SPONSORED",

  METHOD_PENDING = "PENDING",
  METHOD_FEE_ONLINE = "PAYMENT_FEE_ONLINE",

  METHOD_CFF = "CFF",
  METHOD_CGN = "CGN",
  METHOD_QOQA = "QOQA",
  METHOD_DEINDEAL = "DEINDEAL",
  METHOD_REALDEAL = "REALDEAL",
  METHOD_EXTERNAL_INCERT_VOUCHER = "EXTERNAL_INCERT_VOUCHER",

  // METHOD_Swiss_QR_Code_Bank_Transfer = "Swiss_QR_Code_Bank_Transfer",
  METHOD_Swiss_QR_Code_Bank_Transfer = "BANK_TRANSFER_SWISS_QR",

  METHOD_POS_REKA = "POS_REKA",
  METHOD_POS_DIVERSE_VOUCHER = "POS_DIVERSE_VOUCHER",

  EXTERNAL_INCERT_VOUCHER = "EXTERNAL_INCERT_VOUCHER",
  METHOD_POS_OFFER = "POS_OFFER",
  METHOD_OFFER = "OFFER",

  METHOD_BUY_CLUB = "BUY_CLUB",

  METHOD_POS_BIMPLI_CADO = "POS_BIMPLI_CADO",
  METHOD_POS_KADEOS_INFINI = "POS_KADEOS_INFINI",
  METHOD_POS_ANCV_CONNECT = "POS_ANCV_CONNECT",

  METHOD_TOUT_UN_CANTON = "TOUT_UN_CANTON",
  METHOD_CHAPLINS = "CHAPLINS",

  METHOD_GOOGLEPAY = "GOOGLEPAY",
  METHOD_GOOGLEPAY_MASTERCARD = "GOOGLEPAY_MASTERCARD",
  METHOD_GOOGLEPAY_VISA = "GOOGLEPAY_VISA",
  METHOD_GOOGLEPAY_AMEX = "GOOGLEPAY_AMEX",
  METHOD_APPLEPAY = "APPLEPAY",
  METHOD_APPLEPAY_AMEX = "APPLEPAY_AMEX",
  METHOD_APPLEPAY_MAESTRO = "APPLEPAY_MAESTRO",
  METHOD_APPLEPAY_MASTERCARD = "APPLEPAY_MASTERCARD",
  METHOD_APPLEPAY_VISA = "APPLEPAY_VISA",
  METHOD_DISCOVER = "DISCOVER",
  METHOD_REKA = "REKA",
  METHOD_CEMBRAPAY_INVOICE = "CEMBRAPAY_INVOICE",
  METHOD_POWERPAY_INVOICE = "POWERPAY_INVOICE",
  METHOD_CHINA_UNION_PAY = "CHINA_UNION_PAY",
  METHOD_MAESTRO = "MAESTRO",
  METHOD_IDEAL = "IDEAL",
  METHOD_BANCONTACT = "BANCONTACT",
  METHOD_BANCONTACT_MOBILE = "BANCONTACT_MOBILE",
  METHOD_ALIPAY = "ALIPAY",
  METHOD_WECHATPAY_WEB = "WECHATPAY_WEB",
  METHOD_DINERS = "DINERS",
  METHOD_JCB = "JCB",
  METHOD_VPAY = "VPAY",
  METHOD_CART_BANCAIRE = "CART_BANCAIRE",
  METHOD_HELLO_CSE = "HELLO_CSE",
  METHOD_Z_CH_GUTSCHEIN = "Z_CH_GUTSCHEIN",
  // Belgium: the difference between the exact total and the 5-cent-rounded cash
  // amount actually handed over, booked as its own payment line.
  METHOD_CASH_ROUNDING = "CASH_ROUNDING",
}

export enum TransactionTypes {
  TRANSACTION_TYPE_PAYMENT = 1,
  TRANSACTION_TYPE_DISCOUNT = 2,
  TRANSACTION_TYPE_REFUND = 3,
  TRANSACTION_TYPE_TICKET = 4,
  TRANSACTION_TYPE_FEE = 5,
  TRANSACTION_TYPE_TAX = 6,
  TRANSACTION_TYPE_CASH_TRANSFER = 7,
}

export enum PromocodeCampaignType {
  TYPE_PROMO_CODE = 1,
  TYPE_GIFT_CARD,
  TYPE_VOUCHER,
  TYPE_GIFT_CARD_SOLD,
  TYPE_VOUCHER_SOLD,
  TYPE_TICKET_CODE,
  TYPE_TICKET_CODE_SOLD,
  TYPE_MEMBERSHIP,
  TYPE_MEMBERSHIP_SOLD,
}

export enum PromocodeUsage {
  USAGE_PER_QUANTITY = 1,
  USAGE_PER_BOOKING = 2,
  USAGE_PER_TICKET = 3, //productSlotCategory
  USAGE_PER_TIME_SLOT = 4,
  USAGE_PER_PRODUCT = 5,
}

export enum BlockConcurrectTimeTypes {
  BLOCK_CONCURENT_TIME_NONE = 1, // we don't check for concurent time
  BLOCK_CONCURENT_TIME_CATEGORY = 2, // we check for concurent time for the pss category only
  BLOCK_CONCURENT_TIME_ALL = 3, // we check for concurent time for all categories
}

export interface IAccounting {
  _id: string;
  id?: number;
  uuid: string | null;
  bookingId?: number | null;
  bookingUuid: string | null;
  orderSessionId: string;
  promoCodeId?: number | null;
  promoCodeUuid?: string | null;
  value?: number | null;

  paymentCurrency?: Currencies;
  paymentCurrencyValue?: number;
  exchangeRate?: number;
  paymentAndChange?: {
    paymentCurrency: Currencies;
    paymentValue: number;
    changeCurrency: Currencies;
    changeValue: number;
    exchangeRate: number;
    orderTotalInMainCurrency?: number;
    orderTotalInPaymentCurrency?: number;
  };
  addedToCashFloat?: boolean;
  // stores refunded amounts and change given back in main currency
  amountReturned?: number;

  state: AccountingState;
  refund?: number;
  transactionType: TransactionTypes;
  paymentMethod: PaymentMethods;
  createdAt?: string | null;
  message: string | null;
  note?: string | null;
  isDeposit: boolean;
  updatedAt?: string | null;
  completionDate?: string | null;

  currency?: string | null;
  discountId?: number | null;
  discountUuid?: number | null;
  pspReference?: string | null;
  refundPspReference?: string | null;
  posPaymentMethod?: string | null;
  cashRegisterId?: string | null;
  accountingEntriesList: IAccountingEntry[];
  CfUid?: string | null;
  channel: string | null;
  providedCashBill?: number | null;
  merchantReference: string | null;

  // Split info
  transactionTimestamp?: string;
  saleId?: string;
  poiId?: string;
  transactionId?: string;
  splitReference?: string;
  accountCode?: string;
  fullTransactionId?: string | null;
  paymentDetails?: IReceiptPaymentDetails | null;

  promocode?: string;
  createdBy: string;

  // fiskaly transaction uuid
  fiskalyTransactionUuid?: string | null;

  isExternalVoucherService?: boolean;
  originalAccountingUuid?: string | null; // references the original accounting when creating refund accountings
}

// the following fields will have always the same values, we will not set them in the device, will set them in the
// back-end instead
// accounting.paymentMethod = "POS_ADYEN"
// accounting.transactionType = Accounting::TRANSACTION_TYPE_PAYMENT = 1
// accounting.paymentGateway = Accounting::Accounting::PAYMENT_GATEWAY_ORGANISER = "ORGANISER"
// accounting.note = null
// accounting.chargeType = ProductSlotCategory::CHARGE_FLOW_TYPE_DIRECT = 1 // normally we can not tokenize pos payments
// accounting.chargeDate = null
// accounting.tokenID = null
// accounting.transactionID = null
// accounting.authorisationExpiry = null
// accounting.paymentMethodInfo = null
// accounting.authTransactionId = null
// accounting.needToken = false
// accounting.paymentReceivableDate = createdAt + 12 days
// accounting.paymentReceived = false
// accounting.refund = false
// accounting.primary = true
// accounting.refundPspReference = null

export interface ICreateAccounting {
  booking: IProductSlotBooking;
}

export interface IAccountingInfo {
  paymentTool: PaymentTool;
  accountingUUId: string | null;
  paymentToolId?: string | null;
}

export enum PaymentTool {
  None = "None",
  Cash = "Cash",
  CardAuto = "Card",
  CardManual = "Card (External)",
  Discount = "Discount",
  BankTransfer = "Bank transfer",
  Invoice = "Invoice",
  ToBeInvoiced = "To be invoiced",
  Cheque = "Cheque",
  ChequeVacances = "Cheque Vacances",
  ChequeCulture = "Cheque Culture",
  PassCulture = "Pass Culture",
  Chorus = "Chorus",
  CE = "CE",
  OCCYG = "OCCYG",
  CouponSport = "Coupon Sport",
  PosReka = "Reka Check",
  DiverseVoucher = "Diverse Voucher",
  BuyClub = "Buy Club",

  // Promocode = "Promocode",
  // Voucher = "Voucher",
  // GiftCard = "Gift Card",
  // Membership = "Membership",

  CFF = "CFF",
  CGN = "CGN",
  QOQA = "QOQA",
  DEINDEAL = "DEINDEAL",
  REALDEAL = "REALDEAL",
  EXTERNAL_INCERT_VOUCHER = "EXTERNAL_INCERT_VOUCHER",

  Swiss_QR_Code_Bank_Transfer = "Swiss_QR_Code_Bank_Transfer",

  POS_BIMPLI_CADO = "POS_BIMPLI_CADO",
  POS_KADEOS_INFINI = "POS_KADEOS_INFINI",
  POS_ANCV_CONNECT = "POS_ANCV_CONNECT",

  TOUT_UN_CANTON = "TOUT_UN_CANTON",
  CHAPLINS = "CHAPLINS",
  HELLO_CSE = "HELLO_CSE",
  Z_CH_GUTSCHEIN = "Z_CH_GUTSCHEIN",
  ROUNDING = "Rounding",
}

export const PaymentToolMethod = {
  [PaymentTool.Cash]: PaymentMethods.METHOD_POS_CASH,
  [PaymentTool.CardAuto]: PaymentMethods.METHOD_POS_ADYEN,
  [PaymentTool.CardManual]: PaymentMethods.METHODS_POS_CARD,
  [PaymentTool.None]: PaymentMethods.METHOD_POS_UNKNOWN,
  [PaymentTool.Discount]: PaymentMethods.METHODS_POS_DISCOUNT,
  [PaymentTool.BankTransfer]: PaymentMethods.METHODS_POS_BANK_TRANSFER,
  [PaymentTool.Invoice]: PaymentMethods.METHODS_POS_INVOICE,
  [PaymentTool.ToBeInvoiced]: PaymentMethods.METHODS_POS_TO_BE_INVOICED,
  [PaymentTool.Cheque]: PaymentMethods.METHODS_POS_CHEQUE,
  [PaymentTool.ChequeVacances]: PaymentMethods.METHODS_POS_CHEQUE_VACANCES,
  [PaymentTool.ChequeCulture]: PaymentMethods.METHODS_POS_CHEQUE_CULTURE,
  [PaymentTool.PassCulture]: PaymentMethods.METHODS_POS_PASS_CULTURE,
  [PaymentTool.Chorus]: PaymentMethods.METHODS_POS_CHORUS,
  [PaymentTool.CE]: PaymentMethods.METHODS_POS_CE,
  [PaymentTool.OCCYG]: PaymentMethods.METHODS_POS_OCCYG,
  [PaymentTool.CouponSport]: PaymentMethods.METHODS_POS_COUPON_SPORT,
  [PaymentTool.PosReka]: PaymentMethods.METHOD_POS_REKA,
  [PaymentTool.DiverseVoucher]: PaymentMethods.METHOD_POS_DIVERSE_VOUCHER,

  // [PaymentTool.Promocode]: PaymentMethods.POS_PROMO_CODE,
  // [PaymentTool.Voucher]: PaymentMethods.POS_VOUCHER,
  // [PaymentTool.GiftCard]: PaymentMethods.POS_GIFT_CARD,
  // [PaymentTool.Membership]: PaymentMethods.POS_MEMBERSHIP,

  [PaymentTool.CFF]: PaymentMethods.METHOD_CFF,
  [PaymentTool.CGN]: PaymentMethods.METHOD_CGN,
  [PaymentTool.QOQA]: PaymentMethods.METHOD_QOQA,
  [PaymentTool.DEINDEAL]: PaymentMethods.METHOD_DEINDEAL,
  [PaymentTool.REALDEAL]: PaymentMethods.METHOD_REALDEAL,

  [PaymentTool.EXTERNAL_INCERT_VOUCHER]:
    PaymentMethods.METHOD_EXTERNAL_INCERT_VOUCHER,
  [PaymentTool.Swiss_QR_Code_Bank_Transfer]:
    PaymentMethods.METHOD_Swiss_QR_Code_Bank_Transfer,
  [PaymentTool.BuyClub]: PaymentMethods.METHOD_BUY_CLUB,
  [PaymentTool.POS_BIMPLI_CADO]: PaymentMethods.METHOD_POS_BIMPLI_CADO,
  [PaymentTool.POS_KADEOS_INFINI]: PaymentMethods.METHOD_POS_KADEOS_INFINI,
  [PaymentTool.POS_ANCV_CONNECT]: PaymentMethods.METHOD_POS_ANCV_CONNECT,
  [PaymentTool.TOUT_UN_CANTON]: PaymentMethods.METHOD_TOUT_UN_CANTON,
  [PaymentTool.CHAPLINS]: PaymentMethods.METHOD_CHAPLINS,
  [PaymentTool.HELLO_CSE]: PaymentMethods.METHOD_HELLO_CSE,
  [PaymentTool.Z_CH_GUTSCHEIN]: PaymentMethods.METHOD_Z_CH_GUTSCHEIN,
  [PaymentTool.ROUNDING]: PaymentMethods.METHOD_CASH_ROUNDING,
};

export enum PaymentCard {
  Mastercard = "MASTERCARD",
  Visa = "VISA",
  TWINT = "TWINT",
}

export interface IReceiptPaymentDetails {
  date: string;
  time: string;
  card: string;
  status: string;
  authCode: string;
  tender: string;
  reference: string;
  AID: string;
  MID: string;
  TID: string;
  PTID?: string;
  currency: string;
  total: string;
  posEntryMode: string;
  paymentMethod: string;
}
